<template>
  <div class="d-inline-block">
    <vs-dropdown >
      <div class="p-2 px-4 mr-4 shadow-drop rounded-lg d-theme-dark-bg cursor-pointer flex items-center justify-center text-sm font-medium">
        <span class="mr-1">Descargar</span>
        <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
      </div>

      <vs-dropdown-menu>
        <vs-dropdown-item v-if="document['sign_status'] === 3" @click="downloadNom151(document['uuid'])">
          Constancia de conservación
        </vs-dropdown-item>
        <vs-dropdown-item v-if="document['sign_status'] === 3" @click="downloadXml(document['uuid'])">
          XML
        </vs-dropdown-item>
        <vs-dropdown-item v-if="document['sign_status'] === 3" @click="downloadPdf(document['uuid'])">
          PDF Firmado
        </vs-dropdown-item>
        <vs-dropdown-item @click="downloadPdfOriginal(document['uuid'])">
          PDF Original
        </vs-dropdown-item>
        <vs-dropdown-item v-if="document['sign_status'] === 3" @click="downloadAll(document['uuid'])">
          Expediente en ZIP
        </vs-dropdown-item>
        <vs-dropdown-item v-if="document['sign_status'] === 3" divider :to="'/verify/' + document['uuid']">
          Validar documento
        </vs-dropdown-item>
      </vs-dropdown-menu>
    </vs-dropdown>

    <vs-prompt
      @accept="keepDownload"
      @close="closePrompt"
      title="Aviso"
      accept-text="Aceptar"
      cancel-text="Cancelar"
      :active.sync="nom151Prompt">
      <div>
        El archivo de Constancia de Conservación se encuentra en formato ASN.1 el cual requiere un visor asociado y se recomienda para usuarios avanzados.
        <br>
        <a href="https://ayuda.verificamex.com" target="_blank">Conoce más acerca del formato ASN.1</a>
      </div>
    </vs-prompt>
  </div>
</template>

<script>
export default {
  name: "DownloadDropDown",
  props: ["document"],
  data() {
    return {
      nom151Prompt: false,
      uuid: null
    }
  },
  methods: {
    downloadXml(uuid) {
      this.$store.dispatch("document/downloadXml", {uuid: uuid})
    },
    downloadPdfOriginal(uuid) {
      this.$store.dispatch("document/downloadPdfOriginal", {uuid: uuid})
    },
    downloadPdf(uuid) {
      this.$store.dispatch("document/downloadPdf", {uuid: uuid})
    },
    keepDownload() {
      this.$store.dispatch("document/downloadNom151", {uuid: this.uuid})
    },
    downloadNom151(uuid) {
      this.uuid = uuid;
      this.nom151Prompt = true;
    },
    downloadAll(uuid) {
      this.$store.dispatch("document/downloadAll", {uuid: uuid});
    },
    closePrompt() {
      this.nom151Prompt = false;
    }
  }
}
</script>

<style scoped>

</style>
